import {get, writable} from "svelte/store";
import {cargaUno, actualiza, crea} from "../Api/usuarios";

const estadoInicial = {
  cargando: true,
  error: null,
  usuario: null
};

const store = writable(estadoInicial);

export default {
  subscribe: store.subscribe,
  cargar: (id) => {
    const timeout = setTimeout(() => store.update(valor => ({...valor, cargando: true})), 300);

    store.update(() => estadoInicial);

    cargaUno(id)
        .then(usuario => store.update(valor => ({...valor, usuario})))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => {
          clearTimeout(timeout);
          store.update(valor => ({...valor, cargando: false}));
        });
  },
  actualizaCampo: (campo, valor) => {
    store.update(estado => ({
      ...estado,
      usuario: {...estado.usuario, [campo]: valor}
    }));
  },
  nuevo: () => {
    store.set({
      cargando: false,
      error: null,
      usuario: {
        nombre: '',
        email: ''
      }
    });
  },
  guarda: () => {
    const usuario = get(store).usuario;

    const promesa = usuario.id ? actualiza(usuario) : crea(usuario);
    return promesa
        .then(usuario => store.update(valor => ({...valor, error: false, usuario})))
        .catch(error => store.update(valor => ({...valor, error})));
  }
}